import { render } from "./IndexView.vue?vue&type=template&id=005013b1&scoped=true"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=005013b1&scoped=true&lang=css"

import exportComponent from "/Users/yimiqidage/workspace-fe/chrome-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005013b1"]])

export default __exports__